


































































































































































































import {
    ConfirmModal,
    ESearch,
    Pagination,
    Scrollbar,
    SvgImage,
    TailwindTableTabs,
    Sort,
    CardLayoutCardSkeleton,
} from '@/app/components';
import { TButton } from '@/app/components/common';
import { useFacetsFilters, useFeatureFlags, useSearch } from '@/app/composable';
import store from '@/app/store';
import { useAlerts } from '@/modules/alert/composable';
import { AlertSourceType } from '@/modules/alert/constants/alert.constants';
import { SearchAPI } from '@/modules/search/api';
import { RefreshIcon } from '@vue-hero-icons/outline';
import { BellIcon } from '@vue-hero-icons/solid';
import { computed, defineComponent, onBeforeUnmount, ref } from '@vue/composition-api';
import { ScalingSquaresSpinner as OrbitSpinner } from 'epic-spinners';
import * as R from 'ramda';
import { ExclamationIcon } from '@vue-hero-icons/solid';
import { AssetsAPI } from '../api';
import { useAssetFacets } from '../composable/asset-facets';
import { useAssetFilters } from '../composable/asset-filters';
import { AssetSortingOption, AssetTypeId, AssetTypes, StatusCode, AssetType } from '../constants';
import { CardLayout } from '@/app/components';
// import { Asset } from '../types';
import { isNil } from 'ramda';
import { AssetOverview } from '../components';

export default defineComponent({
    name: 'Assets',
    metaInfo: {
        title: 'My Assets',
    },
    components: {
        OrbitSpinner,
        CardLayout,
        SvgImage,
        ConfirmModal,
        TailwindTableTabs,
        Pagination,
        Scrollbar,
        ESearch,
        RefreshIcon,
        BellIcon,
        TButton,
        ExclamationIcon,
        Sort,
        CardLayoutCardSkeleton,
        AssetOverview,
    },
    setup(props, { root }) {
        const { flag } = useFeatureFlags();
        const isAlertsEnabled = flag('alerts');
        const isAnalyticsEnabled = flag('analytics');
        // const showDeleteModal = ref(false);
        // const selectedQuery = ref(null);
        const searchableFields = [
            {
                label: 'title',
                key: 'name',
                textColorClasses: 'text-primary-700',
                backgroundClasses: 'bg-primary-700',
                highlightClasses: 'bg-primary-300',
                widthClasses: 'pl-16 ml-2',
            },
            {
                label: 'description',
                key: 'description',
                textColorClasses: 'text-teal-700',
                backgroundClasses: 'bg-teal-700',
                highlightClasses: 'bg-teal-300',
                widthClasses: 'pl-28 ml-2',
            },
            {
                label: 'tags',
                key: 'metadata.general.tags',
                textColorClasses: 'text-purple-700',
                backgroundClasses: 'bg-purple-700',
                highlightClasses: 'bg-purple-300',
                widthClasses: 'pl-20 ',
            },
        ];
        const openFilters = ref<boolean>(true);
        const assetTabs = computed(() => {
            const tabs = [
                { key: 'mine', label: 'Mine' },
                { key: 'all', label: 'All' },
            ];
            if (isAnalyticsEnabled.value) tabs.push({ key: 'results', label: 'Results' });
            if (isAnalyticsEnabled.value) tabs.push({ key: 'models', label: 'Models' });
            return tabs;
        });
        const pageSize = 48;
        const showDeleteModal = ref(false);
        const toBeDeleted = ref<number | null>(null);
        const facets = ref<Record<string, { value: string; count: number; selected: boolean }[]>>({});
        const assets = ref<any>([]);
        const rejectedItems = ref<number>(0);
        const totalResults = ref<number>(0);
        const user = ref(store.state.auth.user);
        const affectedPipelinesAndQueries = ref<{ pipelines: number; queries: number }>({ pipelines: 0, queries: 0 });

        const queryParams = computed(() => JSON.stringify(root.$route.query));

        const { checkAlert, fetchAlerts } = useAlerts(root, [AlertSourceType.Dataset, AlertSourceType.Result]);
        fetchAlerts();

        const refreshProvenanceIds = computed(() => store.state.notificationEngine.refresh.provenanceIds);

        const refresh = computed(
            () =>
                refreshProvenanceIds.value.length &&
                assets.value.find(
                    (asset: any) =>
                        asset.status === StatusCode.Uploading &&
                        asset.value?.provenanceAssetWorkflowIds &&
                        asset.value.provenanceAssetWorkflowIds.some((workflowId: string) =>
                            refreshProvenanceIds.value.includes(workflowId),
                        ),
                ),
        );

        const setSearchQuery = () => {
            switch (tab.value) {
                case 'all':
                    searchQuery.value.settings.organisationId = undefined;
                    searchQuery.value.settings.userId = undefined;
                    break;
                case 'mine':
                default:
                    searchQuery.value.settings.organisationId = user.value.organisationId;
                    searchQuery.value.settings.userId = user.value.id;
                    break;
            }
        };

        const search = () => {
            setCommonSearchQueryValues();

            searchQuery.value.query.settings = query.value.settings;
            searchQuery.value.settings.excludeSchema = true;

            setQueryParams();

            exec(SearchAPI.facetedSearch(searchQuery.value)).then((res: any) => {
                assets.value = res.data?.results;
                facets.value = res.data?.facets;
                rejectedItems.value = res.data?.accessControl?.rejectedItems || 0;
                totalResults.value = res.data?.total;

                // keep only selected statuses
                if (get('reset') && facets.value?.status) {
                    const facetStatus = facets.value.status
                        .filter((statusFacet: any) => statusFacet.selected)
                        .map((statusFacet: any) => statusFacet.value);
                    const statuses = R.clone(searchQuery.value.facets.status);
                    if (!isNil(statuses))
                        statuses.forEach((statusFacet: string) => {
                            if (!facetStatus.includes(statusFacet))
                                searchQuery.value.facets.status.splice(
                                    searchQuery.value.facets.status.indexOf(statusFacet),
                                    1,
                                );
                        });
                    root.$router.replace({
                        name: 'assets',
                    });
                }
            });
        };

        const {
            exec,
            loading,
            error,
            get,
            textNumberFilters,
            page,
            sortBy,
            tab,
            query,
            searchQuery,
            setTab,
            updateCurrentPage,
            facetChanged,
            filterChanged,
            sortByChanged,
            clearFilters,
            setCommonSearchQueryValues,
            setQueryParams,
            unsubscribeSearch,
            sortingFields,
        } = useSearch(root, 'assets', pageSize, AssetSortingOption, 'mine', setSearchQuery, search, [
            'spatialCoverage',
        ]);

        onBeforeUnmount(() => {
            unsubscribeSearch.value ? unsubscribeSearch.value() : undefined;
            if (refresh.value) store.dispatch.notificationEngine.clearRefreshProvenanceIds();
        });

        const { assetFacets, datasetFacets, resultFacets, modelFacets } = useAssetFacets(get);

        const { assetFilters, datasetFilters, resultFilters, modelFilters } = useAssetFilters(get);

        const { calculateSearchedFacets, calculateSearchedFilters, defaultValue } = useFacetsFilters([
            'spatialCoverage',
        ]);

        const assetTypeSelected = computed(() => {
            const assetType = Object.values(AssetTypes).includes(tab.value) ? tab.value : 'assets';
            if (rejectedItems.value === 1) return assetType.slice(0, -1);
            return assetType;
        });

        const facetsInfo = computed(() => {
            switch (tab.value) {
                case AssetTypes.Datasets:
                    return datasetFacets.value;
                case AssetTypes.Results:
                    return resultFacets.value;
                case AssetTypes.Models:
                    return modelFacets.value;
                default:
                    return assetFacets.value;
            }
        });

        const filtersInfo = computed(() => {
            switch (tab.value) {
                case AssetTypes.Datasets:
                    return datasetFilters.value;
                case AssetTypes.Results:
                    return resultFilters.value;
                case AssetTypes.Models:
                    return modelFilters.value;
                default:
                    return assetFilters.value;
            }
        });

        const currentSearchedFacetsFilters = computed(() =>
            calculateSearchedFacets(searchQuery.value.facets, facetsInfo.value).concat(
                calculateSearchedFilters(searchQuery.value.filters, filtersInfo.value),
            ),
        );

        const edit = (id: number, assetTypeId: number) => {
            if (assetTypeId === 3) {
                root.$router.push({
                    name: 'assets:model:edit',
                    params: { id: `${id}`, queryParams: queryParams.value },
                });
            } else {
                root.$router.push({
                    name: 'assets:edit',
                    params: { id: `${id}`, queryParams: queryParams.value },
                });
            }
        };

        const view = (id: number) => {
            root.$router.push({
                name: 'assets:view',
                params: { id: `${id}`, queryParams: queryParams.value },
            });
        };

        const navigate = (provenanceId: string, assetTypeId: number) => {
            if (assetTypeId === AssetTypeId.Dataset)
                root.$router.push({ name: 'data-checkin-jobs:edit', params: { id: provenanceId } });
            else
                root.$router.push({
                    name: 'workflow-designer:edit',
                    params: { id: provenanceId, backTo: 'assets', queryParams: queryParams.value },
                });
        };

        const destroy = async () => {
            if (toBeDeleted.value) {
                exec(AssetsAPI.deleteAsset(toBeDeleted.value))
                    .then(async (res: any) => {
                        const asset = assets.value.find((item: any) => item.id === toBeDeleted.value);
                        root.$set(asset, 'status', res.data.status);
                        root.$set(asset, 'updatedAt', res.data.updatedAt);
                        toBeDeleted.value = null;

                        (root as any).$toastr.s('Asset deleted successfuly', 'Success');
                        await search();
                    })
                    .catch(() => {
                        (root as any).$toastr.e('Deleting Asset failed', 'Error');
                    });
            }
        };

        const confirmationDeleteMessage = computed(() => {
            let message =
                'Deleting this asset will permanently remove all its data yet its metadata will remain for provenance reasons.';
            if (affectedPipelinesAndQueries.value.pipelines > 0 || affectedPipelinesAndQueries.value.queries > 0) {
                message = message + ' There ';
                message =
                    message +
                    `${
                        affectedPipelinesAndQueries.value.pipelines + affectedPipelinesAndQueries.value.queries > 1
                            ? 'are '
                            : 'is '
                    }`;
                if (affectedPipelinesAndQueries.value.pipelines > 0) {
                    message =
                        message +
                        `<span class= 'font-bold'>${affectedPipelinesAndQueries.value.pipelines}</span> Analytics Pipeline(s) `;
                }
                if (affectedPipelinesAndQueries.value.pipelines > 0 && affectedPipelinesAndQueries.value.queries > 0) {
                    message = message + 'and ';
                }
                if (affectedPipelinesAndQueries.value.queries > 0) {
                    message =
                        message +
                        `<span class= 'font-bold'>${affectedPipelinesAndQueries.value.queries}</span> Retrieval Querie(s) `;
                }
                message =
                    message +
                    `that ${
                        affectedPipelinesAndQueries.value.pipelines > 1 || affectedPipelinesAndQueries.value.queries > 1
                            ? 'are'
                            : 'is'
                    } currently using this asset and will be affected.`;
            }
            message =
                message +
                ' Please note that this action cannot be undone! Are you sure you still want to delete this asset?';
            return message;
        });

        const confirmDelete = (id: any) => {
            toBeDeleted.value = id;
            exec(AssetsAPI.getAffectedPipelinesQueries(id))
                .then((res: any) => {
                    affectedPipelinesAndQueries.value = res.data;
                    showDeleteModal.value = true;
                })
                .catch(() => {
                    (root as any).$toastr.e('Deleting Asset failed', 'Error');
                });
        };

        textNumberFilters.value = {
            relatedPipeline: defaultValue(get, 'relatedPipeline', false),
            assetOrigin: defaultValue(get, 'assetOrigin', false),
            derivativeAssets: defaultValue(get, 'derivativeAssets', false),
        };
        setSearchQuery();
        search();

        const archiveAsset = (id: number) => {
            exec(AssetsAPI.archiveAsset(id))
                .then(() => {
                    const idx = assets.value.findIndex((asset: any) => asset.id === id);
                    assets.value[idx].status = StatusCode.Archived;
                    (root as any).$toastr.s('Model Asset archived successfuly', 'Success');
                })
                .catch(() => {
                    (root as any).$toastr.e('Archiving Model Asset failed', 'Error');
                });
        };

        const restoreAsset = (id: number) => {
            exec(AssetsAPI.restoreArchivedAsset(id))
                .then(() => {
                    const idx = assets.value.findIndex((asset: any) => asset.id === id);
                    assets.value[idx].status = StatusCode.Available;
                    (root as any).$toastr.s('Model Asset restored successfuly', 'Success');
                })
                .catch(() => {
                    (root as any).$toastr.e('Restoring Model Asset failed', 'Error');
                });
        };

        const modalConfirmed = () => {
            showDeleteModal.value = false;
            destroy();
        };

        const cancelAction = () => {
            showDeleteModal.value = false;
            toBeDeleted.value = null;
        };

        const refreshPage = () => {
            search();
            store.dispatch.notificationEngine.clearRefreshProvenanceIds();
        };

        const assetType = (asset: any) => {
            switch (asset.assetTypeId) {
                case AssetTypeId.Model:
                    return {
                        type: AssetType.Model,
                        class: 'text-cherry-700',
                    };
                case AssetTypeId.Result:
                    return {
                        type: AssetType.Result,
                        class: 'text-blue-800',
                    };
                default:
                    return {
                        type: AssetType.Dataset,
                        class: 'text-orange-800',
                    };
            }
        };

        return {
            loading,
            error,
            assets,
            edit,
            view,
            destroy,
            confirmDelete,
            showDeleteModal,
            tab,
            assetTabs,
            setTab,
            archiveAsset,
            restoreAsset,
            modalConfirmed,
            cancelAction,
            pageSize,
            totalResults,
            updateCurrentPage,
            openFilters,
            navigate,
            facets,
            facetChanged,
            searchQuery,
            sortingFields,
            sortByChanged,
            query,
            sortBy,
            page,
            rejectedItems,
            assetTypeSelected,
            filterChanged,
            clearFilters,
            queryParams,
            facetsInfo,
            filtersInfo,
            currentSearchedFacetsFilters,
            textNumberFilters,
            refresh,
            refreshPage,
            affectedPipelinesAndQueries,
            confirmationDeleteMessage,
            checkAlert,
            searchableFields,
            isAlertsEnabled,
            isAnalyticsEnabled,
            AssetType,
            assetType,
        };
    },
});
